/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import abstractAdministrativeLitigationCaseTranslations from "./abstractAdministrativeLitigationCaseTranslations";

const civilServiceLawTranslations = {
  label: "Beamtenrecht",
  ...abstractAdministrativeLitigationCaseTranslations,
  civilServiceStatus: {
    label: "Beamtenstatus",
    values: {
      active: "Aktiv (Beamter auf Lebenszeit, Beamter auf Probe, Beamter auf Widerruf)",
      retired: "Ruhestand (Pensionär)",
    },
  },
  personnelNumber: {
    label: "Personalnummer",
  },
  objectiveClient: {
    label: "Art der Gegenseite",
    values: {
      moneyAndRefund: "Behörde",
      careerAndEmployment: "Dienststelle",
    },
  },
};

export default civilServiceLawTranslations;
